import { render, staticRenderFns } from "./scene-bookmark.vue?vue&type=template&id=3c6ef206&"
import script from "./scene-bookmark.vue?vue&type=script&lang=js&"
export * from "./scene-bookmark.vue?vue&type=script&lang=js&"
import style0 from "./scene-bookmark.vue?vue&type=style&index=0&id=3c6ef206&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports